import { FileList } from "../types/quickOrder";

const readFileAsArrayBuffer = (file: File): Promise<ArrayBuffer> =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.readAsArrayBuffer(file);
  });

const buffersAreEqual = (buf1: ArrayBuffer, buf2: ArrayBuffer): boolean => {
  if (buf1.byteLength !== buf2.byteLength) return false;
  const view1 = new Uint8Array(buf1);
  const view2 = new Uint8Array(buf2);
  for (let i = 0; i < view1.length; i++) {
    if (view1[i] !== view2[i]) return false;
  }
  return true;
};

const getCleanedStateFiles = (
  uploadedFiles: FileList[],
  newFiles: File[]
): FileList[] => {
  return uploadedFiles.filter((existingFile: FileList) => {
    return !newFiles.some(
      (newFile) =>
        existingFile.fileName === newFile.name &&
        existingFile.attachment.size === newFile.size &&
        !existingFile.isActive
    );
  });
};

const getUsedIndexesAndNextIndex = (
  cleanedStateFiles: FileList[],
  labelName: string
): { usedIndexes: Set<number>; nextIndex: number } => {
  const usedIndexes = new Set<number>();
  cleanedStateFiles.forEach((file) => {
    const match = file.fileName.match(new RegExp(`^${labelName}_(\\d+)\\.`));
    if (match) {
      usedIndexes.add(parseInt(match[1], 10));
    }
  });
  const nextIndex = usedIndexes.size > 0 ? Math.max(...usedIndexes) + 1 : 1;
  return { usedIndexes, nextIndex };
};

const buildExistingBuffers = async (
  files: FileList[]
): Promise<{ name: string; size: number; buffer: ArrayBuffer }[]> => {
  return Promise.all(
    files.map(
      (file) =>
        new Promise<{ name: string; size: number; buffer: ArrayBuffer }>(
          (resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              resolve({
                name: file.attachment.name,
                size: file.attachment.size,
                buffer: reader.result as ArrayBuffer,
              });
            };
            reader.readAsArrayBuffer(file.attachment);
          }
        )
    )
  );
};

export {
  readFileAsArrayBuffer,
  buffersAreEqual,
  getCleanedStateFiles,
  getUsedIndexesAndNextIndex,
  buildExistingBuffers,
};
